import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

interface WrapperCellProps {
  sticky?: boolean
  colSpan?: number
}

const WrapperCell = (props: React.PropsWithChildren<WrapperCellProps>) => {
  const { children, sticky, colSpan } = props

  return (
    <Table.Cell sticky={sticky ? { position: 'left' } : undefined} colSpan={colSpan}>
      {children}
    </Table.Cell>
  )
}

export default WrapperCell
